// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticTextPage-module__root--37euj","summary":"StaticTextPage-module__summary--2SBMW Page-module__section--3997J"};